export const closePath = "<path d=\"M4 4 L12 12 M12 4 L4 12\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\"/>"
